export default "__VITE_ASSET__Cy8lh8FA__"